import React, {Component} from 'react';
import {graphql} from 'react-apollo';
import {autobind} from 'core-decorators';
import {formatMoney} from 'core/utils';
import cartQuery from 'graphql/queries/cart.gql';
import Text from 'components/text';
import addToCartMutation from 'graphql/mutations/carts/add-to-cart.gql';
import {Form, Field, Input, Select, Toggle} from 'components/forms';
import Button from 'components/button';
import styles from './styles.css';

@graphql(addToCartMutation, {
    props: ({mutate}) => ({
        onSubmit: variables => mutate({
            variables,
            refetchQueries: [{
                query: cartQuery,
            }],
        }),
    }),
})
@autobind
export default class AddToCart extends Component {
    state = {
        loading: false,
        showSuccess: false,
    };

    componentWillUnmount() {
        clearTimeout(this.timeout);
    }

    getVariationOptions() {
        return this.props.product.variations.map(variation => ({
            value: variation.id,
            label: variation.name,
        }));
    }

    validateStock(quantity, {variation: selectedVariation}) {
        const variation = this.props.product.variations.find(variation => variation.id === selectedVariation);
        return quantity <= variation.stock || 'No hay stock disponible.';
    }

    async handleSubmit(values) {
        this.setState({loading: true});
        await this.props.onSubmit(values);
        this.setState({loading: false, showSuccess: true});
        this.timeout = setTimeout(() => this.setState({showSuccess: false}), 5000);
    }

    render() {
        const {product} = this.props;

        return (
            <Form
                fields={[
                    {key: 'variation', initial: this.getVariationOptions()[0].value},
                    {key: 'quantity', initial: '1', validators: [this.validateStock]},
                    {key: 'withOrganizationLogo', initial: false, required: false},
                ]}
                errors={this.state.errors}
                onSubmit={this.handleSubmit}>
                {({getFieldProps, renderErrors, isValid, values}) => (
                    <div className={styles.fields}>
                        <Field label='Precio' horizontal>
                            <div className={styles.price}>{formatMoney(product, 'price')}</div>
                        </Field>
                        {product.variations.length > 1 && (
                            <Field label={product.variationType} horizontal>
                                <div>
                                    <Select
                                        theme='gray'
                                        options={this.getVariationOptions()}
                                        {...getFieldProps('variation')}
                                    />
                                    {renderErrors('variation')}
                                </div>
                            </Field>
                        )}
                        <Field label='Cantidad' horizontal>
                            <div>
                                <Input className={styles.input} type='number' min={1} {...getFieldProps('quantity')} />
                                {renderErrors('quantity')}
                            </div>
                        </Field>
                        {product.allowOrganizationLogo && (
                            <Field label='Con logo' horizontal>
                                <Toggle
                                    type='checkbox'
                                    {...getFieldProps('withOrganizationLogo')}
                                    disabled={!(values.quantity >= 15)}
                                />
                                <Text variant='h4' color='textSecondary'>
                                                El logo está disponible para pedidos de más de 15 unidades.
                                </Text>
                                {renderErrors('withOrganizationLogo')}
                            </Field>
                        )}
                        {renderErrors('__all__')}
                        {product.isPreOrder && <p className={styles.preOrder}>Fecha de entrega a confirmar</p>}
                        <Form.Actions>
                            <Button theme='yellow' disabled={!isValid() || this.state.loading}>
                                {this.state.loading ? 'AGREGANDO PRODUCTO...' : 'AGREGAR AL CARRITO'}
                            </Button>
                            {this.state.showSuccess && (
                                <div className={styles.success}>
                                    <i className={styles.check} /> Producto agregado al carrito
                                </div>
                            )}
                        </Form.Actions>
                    </div>
                )}
            </Form>
        );
    }
}



// WEBPACK FOOTER //
// ./views/product-detail/add-to-cart/index.js